






















































import { Component, Prop, Vue } from "vue-property-decorator";
import { UserType } from "@/types";
import PlayerTag from "@/components/game/PlayerTag.vue";
import Api from "@/app/api/Api";
import Store from "@/app/store/Store";

@Component({ components: { PlayerTag } })
export default class GameLauncher extends Vue {
  @Prop({ required: true }) user!: UserType;

  error: string | null = null;
  idCreate: string | null = null;
  idJoin: string | null = null;
  idLocal: string | null = null;
  loading = false;

  get idCreated() {
    return this.loading || !!this.idCreate;
  }

  get idJoinIsIdLocal() {
    return this.idJoin && this.idJoin === this.idLocal;
  }

  clearId() {
    this.loading = true;
    Store.local.currentGameId.remove();
    this.idJoin = null;
    this.loading = false;
  }

  gameCreate(e: Event) {
    e.preventDefault();
    if (!this.idCreate) return;

    this.loading = true;
    this.$root.$data.store.gameInit(this.idCreate);
    this.loading = false;
  }

  gameJoin(e?: Event) {
    if (e) e.preventDefault();
    if (!this.idJoin) return;

    this.loading = true;
    this.$root.$data.store
      .gameInit(this.idJoin.toLowerCase(), false)
      .then(() => (this.loading = false))
      .catch((error: string) => {
        this.error = error;
        this.loading = false;
      });
  }

  generateGameId() {
    this.loading = true;
    this.idCreate = null;
    Api.Game.generateId()
      .then((id: string) => {
        this.loading = false;
        this.idCreate = id;
      })
      .catch(() => (this.loading = false));
  }

  mounted() {
    this.idLocal = Store.local.currentGameId.read() || null;
    const fromUrl = window.location.hash.match(/game=([^?]+)/);
    this.idJoin = fromUrl ? fromUrl[1] : Store.local.currentGameId.read() || null;
    if (this.idJoin) this.gameJoin();
  }
}
